import { classNames } from "./Utils/classNames.ts";

const LEVEL_DOT_CLASS_NAMES: Record<string, string> = {
  Starters: "bg-norma-starter",
  Explorers: "bg-norma-explorer",
  Navigators: "bg-norma-navigator",
  Pioneers: "bg-norma-pioneer",
  Voyagers: "bg-norma-voyager",
};

const UNKNOWN_LEVEL_DOT_CLASS_NAME = "bg-slate-300";

export function SpeakingLevelBadge({ level }: { level: string }) {
  return (
    <span
      className={
        "inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-700"
      }
    >
      <span
        className={classNames(
          "h-2 w-2 shrink-0 rounded-full",
          LEVEL_DOT_CLASS_NAMES[level] ?? UNKNOWN_LEVEL_DOT_CLASS_NAME,
        )}
      />
      {level}
    </span>
  );
}
